// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2_mqc","newExpiryDate":"styles_newExpiryDate__1M1Gc","footer":"styles_footer__1wQOz"};